import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { IntegrationEndpoint } from "@modules/erpIntegrations/types";
import { EndpointFormValues } from "@modules/erpIntegrations/validations";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { createEndpointService } from "./service";
import { UseCreateEndpointMutationOptions } from "./types";

export function useCreateEndpointMutation(options?: UseCreateEndpointMutationOptions) {
  const { open } = useNotification();

  return useMutation<IntegrationEndpoint, ApiError, EndpointFormValues>({
    mutationFn: createEndpointService,
    onError: (error) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
    },
    ...options,
  });
}
